var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registration-uf-list"},_vm._l((_vm.ufs),function(uf,i){return _c('div',{key:`sheet-module-${_vm.module}-uf-${i}`,class:`txt-${_vm.module}`},[_c('strong',[_vm._v(_vm._s(uf.name))]),_c('small',[_vm._v("\n      ("+_vm._s(_vm.units[_vm.year].findFromIndex(uf.ufType).code)+")\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }